import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { api } from "@/lib/apiClient";

let cache = null;

export function usePromo() {
  const [promo, setPromo] = useState(cache?.value);
  useEffect(() => {
    if (!cache) cache = { p: api.get("/promotions/current").then(({ data }) => data.promo).catch(() => null) };
    cache.p.then((v) => { cache.value = v; setPromo(v); });
  }, []);
  return promo; // undefined while loading, null when no offer is running
}

const pad = (n) => String(n).padStart(2, "0");

export function PromoCountdown({ endsAt, className = "" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  const end = new Date(endsAt);
  const left = Math.max(0, end - now);
  const d = Math.floor(left / 86400000), h = Math.floor(left / 3600000) % 24, m = Math.floor(left / 60000) % 60, s = Math.floor(left / 1000) % 60;
  const day = end.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" });
  return (
    <div data-testid="promo-countdown" className={`inline-flex flex-wrap items-center gap-x-3 gap-y-1 ${className}`}>
      <span className="flex items-center gap-1.5 text-sm text-[#E8DCC4]"><Clock size={14} className="gold-text" /> Free until <b className="gold-text font-medium">{day}</b></span>
      <span className="font-mono text-sm tabular-nums bg-[#04060B]/70 border border-[#D4AF37]/30 rounded-full px-3 py-0.5 text-starlight" data-testid="promo-countdown-timer">
        {d}d {pad(h)}h {pad(m)}m {pad(s)}s
      </span>
    </div>
  );
}
